import { useNavigate } from "react-router";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import MainTable from "../../components/tables/MainTable";
import endpoints from "../../services/endpoints";
import { TableDetailsItem } from "../../components/tables/tableFunctions";
import useApi from "../../services/useApi";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store";
import { showToast } from "../../components/toastMessage/toastSlice";
import useTranslation from "../../components/CustomHooks/useTranslation";
import { adminContents } from "./components/AdminManagementContent";
import { useState } from "react";

export default function ListofAdmins() {
  const navigation = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { adminList } = endpoints;
  const { translate } = useTranslation(adminContents);
  const { PatchAPI } = useApi();
  const [fetchListTrigger,setFetchListTrigger] = useState(false);
  const TableDetails: { [key: string]: TableDetailsItem } = {
    "User Code": {
      id: "user_code",
      className: "min-w-[120px]",
    },
    "USSD Code": {
      id: "ussd_code",
      className: "min-w-[120px]",
    },
    "User Name": {
      sort: true,
      id: "name",
      custom: ["first_name", "last_name"],
      className: "min-w-[110px]",
    },
    "User Location": {
      id: "user_location",
      custom: ["country", "province", "region"],
      className: "min-w-[280px]",
    },
    "Created Date": {
      sort: true,
      id: "created_date",
      custom: ["created_at"],
    },
    "Phone Number": {
      id: "phone_number",
      custom:['country_code', 'phone_number']
    },
    "Email Address": {
      id: "email_address",
    },
    "E Top Up Wallet Balance": {
      id: "etopup_balance",
      custom: ['etopup_balance']
    },
    "Last Logged In": {
      id: "last_logged_in",
      custom: ["last_logged_in"],
    },
    Status: {
      id: "status",
      toggle: true,
    },
    Actions: {
      id: "actions",
      className: "min-w-[200px]",
      actionTypes: ["edit", "view"],
    },
  };
  const handleActions = async (id: string, key: string, text?: string) => {
    if (key === "view") {
      navigation(`/admin-management/list-of-admins/view-admin/${id}`);
    } else if (key === "edit") {
      navigation(`/admin-management/list-of-admins/edit-admin/${id}`);
    } else if (key === "status") {
      try {
        interface Payload {
          status: boolean;
          extras?: {
            deactivate_reason: string;
          };
        }
        
        const payload: Payload = {
          status: text ? false : true,
        };
        
        if (text) {
          payload.extras = {
            deactivate_reason: text,
          };
        } else {
          payload.status = true;
        }
        

        const res = await PatchAPI(`admins/${id}`, payload);

        if (!res.error) {
          dispatch(
            showToast({
              type: "success",
              message: `Admin ${
                text ? "deactivated" : "activated"
              } successfully`,
            })
          );
          setFetchListTrigger(!fetchListTrigger);
        } else {
          dispatch(
            showToast({
              type: "error",
              message: res.data.message,
            })
          );
        }
      } catch (error) {
        dispatch(
          showToast({
            type: "error",
            message: "An unexpected error occurred. Please try again later.",
          })
        );
        console.error("Error updating admin status:", error);
      }
    }
  };
  const addButtonClick = () => {
    navigation("/admin-management/list-of-admins/add-admin");
  };
  const staticText = {
    emptyScreenText: {
      heading1: translate("There are no admins added yet"),
      heading2: translate("Click “Add Admin” to create one"),
    },
  };

  return (
    <div>
      <Breadcrumbs
        navPath={["Admin Management", "List of Admins"]}
        heading="List of Admins"
        noNavigation
        links={["/admin-management/list-of-admins"]}
        button={{
          buttonName: "Add Admin",
          className: "w-[120px]",
          buttonOnclick: addButtonClick, // Corrected function type
        }}
        hasAddPrivilege={true}
        list={true}
      />
      <MainTable  
        staticText={staticText}
        mainEndPoint={adminList}
        TableDetails={TableDetails}
        handleActions={handleActions}
        params={{ page_number: "1", sort: "created_date+desc" }}
        searchPlaceholder={"Search by user name, user code"}
        filters={true}
        exporting={true}
        enableExcel={true}
        notfoundRoute={{ state: { route: '/admin-management/list-of-admins' } }}
        hasListPrivilege={true}
        hasViewMDPrivilege={true}
        hasEditMDPrivilege={true}
        fetchListTrigger={fetchListTrigger}
      />
    </div>
  );
}